(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function findMainForm(selectorEl) {
      var pid = selectorEl.dataset.productId;
      var byProductId = pid ? document.querySelector('product-form-component[data-product-id="' + pid + '"] form[action$="/cart/add"]') : null;
      if (byProductId) return byProductId;
      var ancestorForm = selectorEl.closest('form[action$="/cart/add"]');
      if (ancestorForm) return ancestorForm;
      var pdForm = document.querySelector('main form[action$="/cart/add"], #MainContent form[action$="/cart/add"]');
      if (pdForm) return pdForm;
      return document.querySelector('form[action$="/cart/add"]');
    }

    function getSelectedQty() {
      var checked = document.querySelector('[data-bundle-selector] input[type="radio"]:checked');
      return checked ? parseInt(checked.value, 10) || 1 : 1;
    }

    function setMainQty(qty) {
      document.querySelectorAll('[data-bundle-selector]').forEach(function (selector) {
        var form = findMainForm(selector);
        if (!form) return;
        var qtyInput = form.querySelector('input[name="quantity"]');
        if (qtyInput) {
          qtyInput.value = qty;
          qtyInput.setAttribute('value', String(qty));
          try {
            qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          } catch (e) {}
        } else {
          var hidden = form.querySelector('input[type="hidden"][data-bundle-qty]');
          if (!hidden) {
            hidden = document.createElement('input');
            hidden.type = 'hidden'; hidden.name = 'quantity';
            hidden.setAttribute('data-bundle-qty', '1');
            form.appendChild(hidden);
          }
          hidden.value = qty;
        }
      });

      var stickyEl = document.querySelector('sticky-add-to-cart');
      if (stickyEl) {
        try { stickyEl.setAttribute('data-bundle-quantity', qty); } catch (e) {}
        var stickyBtn = stickyEl.querySelector('button.sticky-add-to-cart__button, button.add-to-cart-button, button.add-to-cart-text, button[name="add"], button');
        if (stickyBtn) {
          var label = stickyBtn.querySelector('.add-to-cart-text__content, span') || stickyBtn;
        var selectedBundle = document.querySelector('[data-bundle-selector]');
        var savings = selectedBundle ? selectedBundle.dataset['savings' + qty] : '';
        var hatLabel = qty > 1 && savings ? ('Add ' + qty + ' to cart — Save $' + savings) : 'Add to cart';
          if (label && label !== stickyBtn) {
            label.textContent = hatLabel;
          } else if (stickyBtn) {
            stickyBtn.textContent = hatLabel;
          }
        }
      }
    }

    function init() {
      document.querySelectorAll('[data-bundle-selector]').forEach(function (selector) {
        selector.addEventListener('change', function (event) {
          if (event.target.tagName !== 'INPUT' || event.target.type !== 'radio') return;
          setMainQty(parseInt(event.target.value, 10) || 1);
        });
      });

      setMainQty(getSelectedQty());

      document.addEventListener('click', function (event) {
        var btn = event.target.closest('button.sticky-add-to-cart__button, sticky-add-to-cart button, .add-to-cart-button, button[name="add"], button[type="submit"]');
        if (!btn) return;
        var qty = getSelectedQty();
        var stickyParent = btn.closest('sticky-add-to-cart');
        if (stickyParent) {
          var pid = document.querySelector('[data-bundle-selector]')?.dataset?.productId;
          var mainForm = pid ? document.querySelector('product-form-component[data-product-id="' + pid + '"] form[action$="/cart/add"]') : document.querySelector('main form[action$="/cart/add"]');
          if (mainForm) {
            var mainInput = mainForm.querySelector('input[name="quantity"]');
            if (mainInput) {
              mainInput.value = qty;
              mainInput.setAttribute('value', String(qty));
              mainInput.dispatchEvent(new Event('input', { bubbles: true }));
              mainInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          return;
        }
        var ownForm = btn.closest('form[action$="/cart/add"]');
        if (ownForm) {
          var sel = document.querySelector('[data-bundle-selector]');
          if (sel) {
            var pid2 = sel.dataset.productId;
            var mainForm2 = pid2 ? document.querySelector('product-form-component[data-product-id="' + pid2 + '"] form[action$="/cart/add"]') : null;
            if (ownForm === mainForm2 || ownForm.contains(sel) || sel.closest('product-form-component') === ownForm.closest('product-form-component')) {
              var qInp = ownForm.querySelector('input[name="quantity"]');
              if (qInp) {
                qInp.value = qty;
                qInp.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }
        }
      }, true);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    setTimeout(function () { setMainQty(getSelectedQty()); }, 1500);
  })();
  } catch(e) { console.error(e); }
})();

})();
